import {
  EMAIL_RECEIPT
} from './constants'

/**
 * @param {email,payment_id,resend_email} data
 * @return {Axios.IPromise<U>}
 */
export function postEmailReceipt (data) {
  return axios.post(EMAIL_RECEIPT, data, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/email-receipt.js